import { render, staticRenderFns } from "./MyPayment.vue?vue&type=template&id=99b70b7e"
import script from "./MyPayment.vue?vue&type=script&lang=js"
export * from "./MyPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports